import { List, OrderedMap } from 'immutable';
import { useMemo } from 'react';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { useFetchBrandKitsWithColors } from 'reporting-data/hooks/useFetchBrandKitsWithColors';
export const useFetchSingleObjectBrandKitColorPalettes = (deferred = false) => {
  const brandKitColorMapData = useFetchBrandKitsWithColors(deferred);
  const brandKitsWithSingleObjectPalettes = useMemo(() => {
    const brandKitColorMap = isSucceeded(brandKitColorMapData) && brandKitColorMapData.data;
    const shouldDisplayBrandKitColorPalettes = !deferred && brandKitColorMap && Object.keys(brandKitColorMap).length > 0;
    const brandKitColorPalettes = {};
    if (shouldDisplayBrandKitColorPalettes) {
      for (const key in brandKitColorMap) {
        if (brandKitColorMap[key].colorPalette) {
          const brandKit = brandKitColorMap[key];
          const kitPalette = {};
          const paletteScheme = brandKit.colorPalette && brandKit.colorPalette.map(palette => palette.color);
          kitPalette.id = key;
          kitPalette.label = brandKit.name;
          kitPalette.scheme = paletteScheme && List(paletteScheme);
          brandKitColorPalettes[key] = kitPalette;
        }
      }
    }
    return OrderedMap(brandKitColorPalettes);
  }, [brandKitColorMapData, deferred]);
  return {
    soBrandKitMap: brandKitsWithSingleObjectPalettes,
    isLoading: isLoading(brandKitColorMapData) && !deferred
  };
};